import { RequestBuilder } from '@atlas/base';

const requestBuilder = new RequestBuilder();

export function syncRequestBuilderDefaultHeaders(defaultHeaders) {
  if (!defaultHeaders) {
    return;
  }
  for (const [key, value] of Object.entries(defaultHeaders)) {
    requestBuilder.headers.set(key, value);
  }
}

export function syncRequestBuilderAuthFromApiManager(ApiManager) {
  const token = ApiManager.getAuthorizationToken?.();
  if (token) {
    requestBuilder.headers.set('Authorization', `Bearer ${token}`);
  } else {
    requestBuilder.headers.delete('Authorization');
  }
  requestBuilder.headers.set('Content-Type', 'application/json');
}

export default requestBuilder;
